export const LOGIN_TAG_KEYS = [
  'is_logged',       // Fixed: 'true' quando logado, 'false' no logout
  'username',        // user.anuApp OR user.userName
  'name',            // user.name
  'birthdate',       // user.birthdate
  'created_country', // user.country
  'created_state',   // user.state
  'created_city',    // user.city
  // vehicle_manufacturer_* e vehicle_model_* são gerados dinamicamente
];

/**
 * Normaliza strings para formato aceito pelo OneSignal
 * - Lowercase
 * - Remove caracteres especiais
 * - Substitui espaços por underline
 */
const normalizeTagValue = (value: string): string => {
  return value
    .toLowerCase()
    .normalize('NFD') // Decompõe caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Remove diacríticos
    .replace(/[^a-z0-9\s]/g, '') // Remove caracteres especiais
    .trim()
    .replace(/\s+/g, '_'); // Substitui espaços por underline
};

export const buildUserTags = (user: any, isLogged: boolean = true, vehicles: any[] = []): Record<string, string> => {
  const tags: Record<string, string> = {};

  // 1. Sinaliza usuário logado (vazio para remoção no OneSignal)
  tags['is_logged'] = '';

  // 2. Usuário (vazio para remoção no OneSignal)
  tags['name'] = '';
  tags['username'] = '';

  // 3. Dados geográficos do perfil (vazio para remoção no OneSignal)
  tags['birthdate'] = '';

  tags['created_country'] = user?.country ? String(user.country) : '';
  tags['created_state'] = user?.state ? String(user.state) : '';
  tags['created_city'] = user?.city ? String(user.city) : '';

  // 4. Fabricantes e modelos distintos dos veículos
  // Cria um tag individual para cada fabricante e modelo
  if (vehicles && vehicles.length > 0) {
    const manufacturers = new Set<string>();
    const models = new Set<string>();

    vehicles.forEach((vehicle: any) => {
      if (vehicle.uvVm?.vmManufacturer?.manufacturerName) {
        const manufacturer = vehicle.uvVm.vmManufacturer.manufacturerName;
        if (manufacturer !== '_unknown') {
          manufacturers.add(manufacturer);
        }
      }

      if (vehicle.uvVm?.vmName) {
        models.add(vehicle.uvVm.vmName);
      }
    });

    // Gera um tag para cada fabricante: vehicle_manufacturer_<nome> = "1"
    manufacturers.forEach((manufacturer) => {
      const normalizedManufacturer = normalizeTagValue(manufacturer);
      if (normalizedManufacturer) {
        tags[`vehicle_manufacturer_${normalizedManufacturer}`] = '1';
      }
    });

    // Gera um tag para cada modelo: vehicle_model_<nome> = "1"
    models.forEach((model) => {
      const normalizedModel = normalizeTagValue(model);
      if (normalizedModel) {
        tags[`vehicle_model_${normalizedModel}`] = '1';
      }
    });
  }

  return tags;
};
